module.exports = __webpack_public_path__ + "img/img9.7c2b26b8.png";